import { graphql } from "/@/generated";

export const refreshNotifications = graphql(`
  query refreshNotifications {
    refreshNotifications
  }
`);
